export enum DrawSteps {
  GenerateRandomNumbers = 'generateRandomNumbers',
  TopDraw = 'topDraw',
  BronzeDraw = 'bronzeDraw',
}
